import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
import { debounce } from 'debounce';
import { ymPushEvent, ymPushParams } from "./ym";
import { CLICK_ANALYTICS_TYPES, REACH_GOAL_CLICK_TYPE, VIEW_ANALYTICS_TYPES } from "../constants/common";
var isViewAnalyticsKey = function isViewAnalyticsKey(key) {
  return key in VIEW_ANALYTICS_TYPES;
};
var isNotEmpty = function isNotEmpty(item) {
  return Object.keys(item || {}).length;
};
export var pushEvent = function pushEvent(_ref) {
  var location = _ref.location,
    target = _ref.target,
    data = _ref.data;
  return ymPushParams(_defineProperty({}, location, isNotEmpty(data) ? _defineProperty({}, target, data) : target));
};
var getClickType = function getClickType(link) {
  var beelineRegex = /.beeline.ru/;
  var shopRegex = /shop\/details\//;
  var externalRegex = /([a-zA-Zа-яА-Я]{2,}\.)+[a-zA-Zа-яА-Я]{2,}/gi;
  var isExternal = externalRegex.test(link) && !beelineRegex.test(link);
  if (isExternal) {
    return REACH_GOAL_CLICK_TYPE.OutgoingLinkClick;
  }
  if (!isExternal && shopRegex.test(link)) {
    return REACH_GOAL_CLICK_TYPE.BuyButtonClick;
  }
  return REACH_GOAL_CLICK_TYPE.InternalLinkClick;
};
var _items = /*#__PURE__*/new WeakMap();
var _key = /*#__PURE__*/new WeakMap();
var _pushViewEventWithDebounce = /*#__PURE__*/new WeakMap();
var YMPusher = /*#__PURE__*/_createClass(function YMPusher(_key2) {
  var _this = this;
  _classCallCheck(this, YMPusher);
  _classPrivateFieldInitSpec(this, _items, {
    writable: true,
    value: []
  });
  _classPrivateFieldInitSpec(this, _key, {
    writable: true,
    value: void 0
  });
  _defineProperty(this, "location", void 0);
  _classPrivateFieldInitSpec(this, _pushViewEventWithDebounce, {
    writable: true,
    value: debounce(function () {
      var _window, _window$location;
      if (!isViewAnalyticsKey(_classPrivateFieldGet(_this, _key))) return;
      var pathname = ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) || '';
      pushEvent({
        location: "".concat(_this.location).concat(pathname),
        target: VIEW_ANALYTICS_TYPES[_classPrivateFieldGet(_this, _key)],
        data: _classPrivateFieldGet(_this, _items)
      });
      _classPrivateFieldSet(_this, _items, []);
    }, 1000)
  });
  _defineProperty(this, "pushViewEvent", function (item) {
    if (item) {
      _classPrivateFieldGet(_this, _items).push(item);
    }
    _classPrivateFieldGet(_this, _pushViewEventWithDebounce).call(_this);
  });
  _defineProperty(this, "pushClickEvent", function (item, isTab) {
    var _window2, _window2$location;
    var pathname = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.pathname) || '';
    var currentKey = isTab ? "".concat(_classPrivateFieldGet(_this, _key).toString(), "Tab") : _classPrivateFieldGet(_this, _key);
    pushEvent({
      location: "".concat(_this.location).concat(pathname),
      target: CLICK_ANALYTICS_TYPES[currentKey],
      data: item
    });
  });
  _defineProperty(this, "pushReachGoal", function () {
    var _window3, _window3$location;
    var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var blockIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var pathname = ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.pathname) || '';
    var clickType = type || getClickType(link);
    var event = "".concat(pathname, "+").concat(clickType, "+").concat(link, "+").concat(blockIndex, "_").concat(index.toString());
    var prepareEvent = event.replace(/(\/|\.)/g, '_');
    var key = encodeURIComponent(prepareEvent);
    ymPushEvent(key, '');
    ymPushEvent(key, '', 28573041);
  });
  this.location = 'LP_';
  _classPrivateFieldSet(this, _key, _key2);
});
export var AnalyticsPusherTeaser = new YMPusher('teaser');
export var AnalyticsPusherInfo = new YMPusher('info');
export var AnalyticsPusherFAQ = new YMPusher('faq');
export var AnalyticsPusherCard = new YMPusher('card');
export var AnalyticsPusherTariff = new YMPusher('tariff');
export var AnalyticsPusherVideo = new YMPusher('video');
export var AnalyticsPusherSteps = new YMPusher('steps');
export var AnalyticsPusherForm = new YMPusher('form');
export var AnalyticsPusherActionBar = new YMPusher('action_bar');
export var AnalyticsPusherAppBanner = new YMPusher('app_banner');
export var AnalyticsPusherLinks = new YMPusher('link');
export var AnalyticsPusherModal = new YMPusher('modal');
export var AnalyticsPusherTabs = new YMPusher('tabs');
export var AnalyticsPusherService = new YMPusher('service');